import { httpRequest } from "@services/http";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";

export class CommandListPricesheets {
  async run(contractId: number, params?: { is_active?: boolean }): Promise<Pricesheet[]> {
    const query = new URLSearchParams();
    if (params?.is_active != null) query.set("is_active", String(params.is_active));

    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${qs ? `?${qs}` : ""}`;

    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });
    return PricesheetSerializer.fromJsonList(response);
  }
}
